import React from "react";
import linesIcon from "@img/questionary-icon.webp";
import cameraIcon from "@img/cameraIcon.webp";
import chestIcon from "@img/chestIcon.webp";
import headphoneIcon from "@img/headphoneIcon.webp";
import fireIcon from "@img/fireIcon.webp";

export default function QuestionaryLoader({ text = "Мы подбираем товар" }) {
  return (
    <div className="questionary-loader">
      <img
        className="questionary-loader__icon questionary-loader__icon--headphone"
        width={120}
        src={headphoneIcon}
        alt="headphone"
      />
      <img
        className="questionary-loader__icon questionary-loader__icon--fire"
        width={120}
        src={fireIcon}
        alt="fire"
      />
      <img
        className="questionary-loader__icon questionary-loader__icon--chest"
        width={120}
        src={chestIcon}
        alt="chest"
      />
      <img
        className="questionary-loader__icon questionary-loader__icon--camera"
        width={120}
        src={cameraIcon}
        alt="camera"
      />
      <img
        className="questionary-loader__icon questionary-loader__icon--lines-right"
        width={350}
        src={linesIcon}
        alt="line"
      />
      <img
        className="questionary-loader__icon questionary-loader__icon--lines-left"
        width={350}
        src={linesIcon}
        alt="line"
      />
      <p className="questionary-loader__message">Подождите 5 секунд</p>
      <p className="questionary-loader__status">
        {text} <div className="loader-dot"></div>
      </p>
    </div>
  );
}
